import {DEFAULT_ACCENT_COLOR} from '@cohort/shared/schema/common';
import {isDark} from '@cohort/shared-frontend/utils/isDark';
import {BaseButton} from '@cohort/wallet/components/button/BaseButton';
import ErrorPageTemplate from '@cohort/wallet/components/ErrorPageTemplate';
import {Colors} from '@cohort/wallet/lib/Theme';
import type {MerchantWDto} from '@cohort/wallet-schemas/merchant';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';

type DefaultNotFoundPageProps = {
  merchant?: MerchantWDto;
};

const DefaultNotFoundPage: React.FC<DefaultNotFoundPageProps> = ({merchant}) => {
  const navigate = useNavigate();
  const {t} = useTranslation('pages', {keyPrefix: 'notFoundPage'});
  const accentColor = merchant ? merchant.accentColorCode ?? DEFAULT_ACCENT_COLOR : undefined;

  return (
    <ErrorPageTemplate
      title={t('notExist')}
      description={t('sorry')}
      code={404}
      cta={
        merchant && (
          <BaseButton
            style={{
              backgroundColor: accentColor,
              color: accentColor && !isDark(accentColor) ? Colors.Black : Colors.White,
            }}
            text={t('action')}
            onClick={() => navigate('/space/home')}
            tracking={{namespace: 'notfound.back'}}
          />
        )
      }
      merchant={merchant}
    />
  );
};

export default DefaultNotFoundPage;
